import { render } from "./CancelPassModal.vue?vue&type=template&id=45faeb59"
import script from "./CancelPassModal.vue?vue&type=script&lang=js"
export * from "./CancelPassModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__